module.exports = __webpack_public_path__ + "img/icon-thumbs-up.5f76c93e.svg";